import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "disabled", "primaryIcon", "actions", "secondaryItemText", "size", "href", "target", "rel", "primaryIconBackgroundColor", "divider", "lead", "subtitle", "enableLink", "enableSecondaryItem"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useRootRef } from '../../../../system';
export var useListItem = function useListItem(_ref, ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      primaryIcon = _ref.primaryIcon,
      actions = _ref.actions,
      secondaryItemText = _ref.secondaryItemText,
      size = _ref.size,
      href = _ref.href,
      target = _ref.target,
      rel = _ref.rel,
      primaryIconBackgroundColor = _ref.primaryIconBackgroundColor,
      divider = _ref.divider,
      lead = _ref.lead,
      subtitle = _ref.subtitle,
      enableLink = _ref.enableLink,
      enableSecondaryItem = _ref.enableSecondaryItem,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var innerRef = useRootRef(ref);
  return {
    rootProps: _objectSpread(_objectSpread({}, restProps), {}, {
      size: size,
      lead: lead,
      subtitle: subtitle,
      divider: divider,
      disabled: disabled,
      ref: ref,
      enableLink: enableLink
    }),
    primaryListProps: {
      disabled: disabled
    },
    secondaryListProps: {
      lead: lead,
      subtitle: subtitle,
      disabled: disabled
    },
    primaryLeadSubtitle: {
      lead: lead,
      subtitle: subtitle,
      disabled: disabled
    },
    renderSubtitle: !!subtitle && !lead,
    renderLead: !!lead,
    lead: lead,
    subtitle: subtitle,
    secondaryItemText: secondaryItemText,
    actions: actions,
    children: children,
    enablePrimaryIcon: !!primaryIcon,
    primaryIcon: primaryIcon,
    enableSecondaryItem: enableSecondaryItem,
    tagProps: {
      ref: innerRef,
      href: href,
      target: target,
      rel: rel
    },
    Tag: enableLink && !disabled ? 'a' : 'div',
    primaryIconBackgroundColor: primaryIconBackgroundColor,
    primaryIconWrapper: (lead || subtitle) && primaryIconBackgroundColor,
    disabled: disabled,
    primaryIconWrapperProps: {
      disabled: disabled,
      primaryIconBackgroundColor: primaryIconBackgroundColor,
      primaryIcon: primaryIcon
    }
  };
};